export const SiteColor = 'hsla( 150,94.93670886075948%,30.980392156862745% ,1)';